/* Jayone Featured Products carousel — seamless infinite loop.
   The card set is duplicated once ([set][clone]); arrows advance by whole
   cards and, when the scroll crosses one set width, the position is
   teleported back by exactly one set with snap+smooth temporarily off so
   the jump is instant and invisible (identical clone content). A guard
   flag stops the teleport from re-triggering itself. */
(function () {
  function initSection(section) {
    var track = section.querySelector('[data-featured-track]');
    if (!track || track.dataset.looped) return;
    var prev = section.querySelector('.jayone-featured__arrow[data-dir="prev"]');
    var next = section.querySelector('.jayone-featured__arrow[data-dir="next"]');

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) return; // nothing to loop

    // Duplicate the set once; clones are inert to AT + keyboard.
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });
    track.dataset.looped = '1';
    var count = originals.length;

    // One card + gap (distance between adjacent card starts).
    function stride() {
      var a = track.children[0], b = track.children[1];
      if (a && b && b.offsetLeft !== a.offsetLeft) return Math.abs(b.offsetLeft - a.offsetLeft);
      return a ? a.offsetWidth : track.clientWidth;
    }
    // Exact width of one set = left offset of the first clone.
    function setWidth() {
      var firstClone = track.children[count];
      return firstClone ? firstClone.offsetLeft : Math.round(track.scrollWidth / 2);
    }

    var suppress = false;
    function normalize() {
      var w = setWidth();
      if (w <= 0) return;
      var x = track.scrollLeft;
      if (x >= w - 1 || x < 0) {
        var nx = ((x % w) + w) % w; // fold into the first set
        suppress = true;
        var pSnap = track.style.scrollSnapType;
        var pBeh = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';   // don't let mandatory snap fight the jump
        track.style.scrollBehavior = 'auto';   // instant, not animated
        track.scrollLeft = nx;
        requestAnimationFrame(function () {
          track.style.scrollSnapType = pSnap;
          track.style.scrollBehavior = pBeh;
          suppress = false;
        });
      }
    }
    function step(dir) {
      normalize();
      var st = stride();
      var per = Math.max(1, Math.round(track.clientWidth / st)); // whole cards per view
      track.scrollBy({ left: dir * per * st, behavior: 'smooth' });
    }

    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });

    // Touch / trackpad: normalize once motion settles; ignore our own teleport.
    var settle;
    track.addEventListener('scroll', function () {
      if (suppress) return;
      clearTimeout(settle);
      settle = setTimeout(normalize, 150);
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.jayone-featured').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.jayone-featured');
    if (s) initSection(s);
  });
})();
